import { useGetBeamstarFlagsQuery } from '@consigli/hooks';
import { type BeamstarFlag } from '@consigli/types';
import { type ColumnDef } from '@tanstack/react-table';

import { Badge, DataTable } from '@/components';

import { formatDateTime, turnOutcomeMapping, workflowName } from '../format';
import { LoadError } from '../load-error';

const columns: ColumnDef<BeamstarFlag>[] = [
  {
    header: 'Flagged',
    cell: ({ row }) => (
      <span className="whitespace-nowrap text-muted-foreground">
        {formatDateTime(row.original.flaggedAt)}
      </span>
    ),
  },
  { header: 'Building', cell: ({ row }) => row.original.buildingId ?? '-' },
  {
    header: 'Comment',
    cell: ({ row }) => (
      <span className="line-clamp-2 max-w-md whitespace-normal">{row.original.comment}</span>
    ),
  },
  { header: 'Turn', cell: ({ row }) => <Badge {...turnOutcomeMapping[row.original.outcome]} /> },
  {
    header: 'Workflow',
    cell: ({ row }) =>
      row.original.workflowId ? workflowName(row.original.workflowId) : 'Typed message',
  },
];

interface FlagsTabProps {
  days: number;
  onOpenTurn: (conversationId: string, turnId: string) => void;
}

export const FlagsTab = ({ days, onOpenTurn }: FlagsTabProps) => {
  const { data, isFetching, error } = useGetBeamstarFlagsQuery({ days });

  if (error) {
    return <LoadError title="Could not load the flags" error={error} />;
  }

  return (
    <DataTable
      columns={columns}
      data={data ?? []}
      isLoading={isFetching}
      onRowClick={(flag) => onOpenTurn(flag.conversationId, flag.turnId)}
    />
  );
};
